export function ValidateEmail(e: string) {
  // tslint:disable-next-line
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e);
}

export default {
  required: [
    (v: any) => !!v || "Required field",
  ],
  firstName: [
    (v: any) => !!v || "First Name is required",
    (v: any) => (v && v.length <= 255) || "First Name must be less than 255 characters",
  ],
  lastName: [
    (v: any) => !!v || "Last Name is required",
    (v: any) => (v && v.length <= 255) || "Last Name must be less than 255 characters",
  ],
  emailRules: [
    (v: any) => !!v || "E-mail is required",
    (v: any) => ValidateEmail(v) || "E-mail must be valid",
  ],
  emailRulesOptional: [
    (v: any) => !v || ValidateEmail(v) || "E-mail must be valid",
  ],
  noFraction: [
    (v: any) => !v || v % 1 === 0 || "No fractions allowed, use whole numbers",
  ],
  discount: [
    (v: any) => !v || v % 1 === 0 || "No fractions allowed, use whole numbers",
    (v: any) => !v || v <= 100 && v >= 0 || "Enter number between 0 and 100",
  ],
  noZero: [
    (v: any) => (v && /[0-9\.]+/.test(v) && (+v) !== 0) || "Value required and can not be 0",
  ],
};


